import { SurveyRequestInfo } from '../entities/SurveyRequestInfo';

export const getReferencesReferrals = (
  surveyRequestInfo: SurveyRequestInfo,
) => {
  return surveyRequestInfo.referrals.filter(
    (r) => r.relationship !== 'candidate',
  );
};
